import styled from "styled-components";

const ImageMediumPreview = styled.img`
  width: 332px;
  height: 300px;
`;

export default ImageMediumPreview;
